module.exports = __webpack_public_path__ + "stylesheets/about_28325954eefffa3eabeeca66a6156bec.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/about.less
// module id = imWQ
// module chunks = 51